var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(!_vm.showtime)?_c('intro'):_vm._e(),_c('sobre-ciudades-comunes'),_c('about'),_c('topic-mosaic'),_c('videos'),_c('cien-ideas'),_c('incubadora',{attrs:{"event":_vm.showtime,"next":_vm.comingNext}}),_c('who-are-we'),_c('register')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }